import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 20"
}, n = /* @__PURE__ */ e("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M14.625 8.091v-.587c0-3.224-2.52-5.837-5.625-5.837S3.375 4.28 3.375 7.503v.588c.001.7-.2 1.388-.577 1.979l-.923 1.437c-.842 1.313-.2 3.097 1.267 3.512a21.5 21.5 0 0 0 11.716 0c1.466-.415 2.11-2.2 1.267-3.511l-.923-1.438a3.67 3.67 0 0 1-.578-1.979z"
}, null, -1), c = /* @__PURE__ */ e("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M5.25 15.833c.546 1.457 2.018 2.5 3.75 2.5s3.204-1.043 3.75-2.5"
}, null, -1), l = [
  n,
  c
];
function s(d, i) {
  return t(), o("svg", r, [...l]);
}
const h = { render: s };
export {
  h as default,
  s as render
};
